import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SetupPaymentHeader',
  props: {
    title: { default: "Set up payments" }
  },
  emits: ["back"],
  setup(__props: any, { emit }: { emit: ({
  (e: "back"): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, Icon }
}

})